export const setProgressToObj = (key, value, obj) => {
	obj[key] = value;
	return obj;
};